import iviewLocale from 'iview/src/locale/lang/en-US';
export default {
    "locale": "en-US",
    "user": {
        "defaultMenu": "Default menu",
        "pleaseWait": "Please wait",
        "role": "role",
        "title": "Lambda Platform",
        "subtitle": "Lambda Platform",
        "login": "Login",
        "forgot": "Forgot password?",
        "remember": "Remember me",
        "loginTitle": "Login to system",
        "username": "Username",
        "email": "e-mail",
        "password": "Password",
        "loginSuccess": "Successfully logged in. Please wait for a moment!",
        "loginError": "Sorry, an error occurred while logging in!!",
        "emailRequired": "Please enter an email address",
        "emailSendError": "An error occurred while sending the email",
        "forgotDescription": "Enter your email address and reset your password",
        "sendPasswordResetCode": "Receive password reset code by email",
        "passwordConfirm": "Password verification",
        "userNotFound": "User not found !!!",
        "codeSentError": "An error occurred while sending the password update code!",
        "passwordReset": "Password reset",
        "passwordResetCode": "Password reset code",
        "passwordResetCodeSent": "Password update code sent successfully !",
        "passwordResetCodeRequired": "Password change code not included !!!",
        "passwordResetSuccess": "Password successfully updated !",
        "passwordConfirmError": "Password authentication did not match !!!",
        "passwordResetCodeIncorrect": "The password recovery code is incorrect !!!",
        "passwordResetCodeTimeout": "Password recovery code has expired !!!",
        "noReply": "This email was sent automatically, so there is no need to reply.",
        "databaseview": "Database, view",
        "dataBase": "database",
        "view": "VIEW",
        "add": "Add",
        "characteristics": "Characteristics",
        "basic": "Basic",
        "column": "Column",
        "name": "Name",
        "optional": "Optional",
        "filter": "filter",
        "data": "Data",
        "save": "save",
        "tableList": "Table list",
        "aggregation": "Aggregation",
        "sort": "Sort",
        "use": "Use",
        "grouping": "Grouping",
        "type": "Type",
        "alias": "Alias",
        "dataProcessing": "Data processing",
        "select": "Select",
        "pleaseEnterSearchValue": "Please enter a search value",
        "user": "User",
        "users": "Users",
        "totalEmployees": "Total employees",
        "deleted": "Deleted",
        "searchForInformation": "Search for information",
        "addUser": "Add a user",
        "noData": "No matching data",
        "page": "page",
        "shows": "shows",
        "categorySearch": "category search",
        "image": "image",
        "lastName": "last name",
        "firstName": "first name",
        "registrationNumber": "Registration number",
        "dateOfBirth": "Date of birth",
        "gender": "gender",
        "men": "Men",
        "women": "Women",
        "phone": "phone",
        "resetFrom": "Reset Form",
        "permission": "Permission",
        "loginName": "Login name",
        "confirmPassword": "Confirm password",
        "personalInformation": "Personal information",
        "changePassword": "Change password",
        "settings": "Settings",
        "logOut": "Log out",
        "pleaseSelectRole": "Please select a role",
        "administraationRightsManagment": "Administration rights management",
        "additional": "additional",
        "dataSource": "Data source",
        "chart": "Chart",
        "userList": "User list",
        "import": "Import",
        "register": "Register",
        "confirm": "Confirm",
        "menuSelection": "Menu selection",
        "noMatchingData": "No matching data",
        "nickName": "Nickname",
        "note": "Note",
        "pleaseEnterVisibleName": "Please enter a visible name",
        "firstNameandLastName": "First name & last name",
        "mobile": "Mobile",
        "createdDate": "created date",
        "registrationConfirmed": "REGISTRATION CONFIRMED",
        "registrationIsNotConfirmed": "REGISTRATION IS NOT CONFIRMED",
        "success": "success",
        "systemUpdate": "System update",
        "sendDataStructure": "Send data structure",
        "pleaseReEnterYourPassword": "Re-enter your password?",
        "theValueIsRegistered": "The value is registered",
        "possibleTableView": "Possible table and view",
        "table": "Table",
        "ascending": "Ascending",
        "descending": "descending",
        "byLoginName": "by login name",
        "dateAdded": "Date added",
        "inPage": "in page",
        "show": "Show",
        "outOf": "total",
        "fromUsers": "from users",
        "showing": "showing",
        "noInfo": "No information ",
        "ruconfinfo": "Are you confident in retrieving employee information?",
        "ruconfinfoDelete": "Are you sure you want to delete employee information completely?",
        "created": "Created",
        "userDeleted": "The user has been deleted",
        "_logout": "Logout",
        "_cancel": "Cancel",
        "listOfDeletedUsers": "List of deleted users",
        "by": "by",
        "no": "No",
        "yes": "Yes",
        "completeDestruction": "Complete destruction",
        "recovery": "Recovery",
        "errorOccWhileDeleting": "An error occurred while deleting",
        "userInformationRestored": "User information restored",
        "errorOccurredWhileRetrievingData": "An error occurred while retrieving the data.",
        "total": "total",
        "edit": "Edit",
        "pleaseLogInUsingYourRegUnamePassword": "Please log in using your registered username and password",
        "frequentlyAskedQuestions": "Common question",
        "toContaqt": "to contact",
        "downloadYourMobileApp": "Download your mobile app.",
        "instructionsUse": "Instructions for use",
        "hayg": "Mongolia, Ulaanbaatar, Sukhbaatar district, 9th khoroo, Ikh toiruu 54, Computer Mall, 8th floor, room 8002",
        "plseResUrPassUsingUrRegisteredEmail": "Please reset your password using your registered email address?",
        "downloadAppHere": "Download the app here",

        "learningManagementSystem": "Learning Management System",
        "amjilt": "Amjilt",
        "system_features": "System features",
        "ebs": "EBS",
        "web_site_data_monitoring": "Web site data monitoring",
        "training_data_statistics": "Training data statistics",
        "schedule_report": "Schedule report",
        "track_by_keyword": "Track by keyword",
        "to_calculate_the_program_choice_of_teachers_and_students": "To calculate the program choice of teachers and students",
    },
    "agent_wizard": {
        "confirm_registration_information": "Confirm registration information",
        "step": "Step",
        "hello": "Hello ?",
        "your_name": "Your name",
        "your_last_name": "Your last name",
        "name_desc": "Please write your real name in either Latin or Mongolian letters, up to a maximum of 75 characters.",
        "last_name_desc": "Please write your last name in either Latin or Mongolian letters, up to a maximum of 75 characters.",
        "your_birthday": "Your birthday",
        "your_gender": "Your gender",
        "women": "Female",
        "man": "Men",
        "_register": "Registration number",
        "register_desc": "Please enter your registration number. Please write in Mongolian only.",
        "example": "For example",
        "contact_information": "Contact information",
        "your_email_address": "Your E-mail address",
        "email_desc": "Please enter your email address. Please write in Latin characters, lowercase, without spaces.",
        "your_phone_number": "Your cell phone number",
        "phone_desc": "Please enter your mobile number. Use only numbers and spaces.",
        "profile_image": "Profile image",
        "profile_image_uploud": "Upload a profile picture",
        "profile_desc": "Please select your profile picture and upload it to the server. Image size should not exceed 1mb.",
        "your_new_password": "Your new password",
        "password_desc": "Passwords must be in Latin letters, uppercase and lowercase letters, numbers, special characters, with no spaces.",
        "rep_your_new_password": "Repeat your new password",
        "_prev": "Previous",
        "_next": "Next",
        "enter_personal_information": "Please enter your personal information correctly!",
        "enter_contact_information": "Please enter your contact information correctly!",
        "please_change_your_password": "Please change your password! Your new password will be used in the future",
        "please_contact_system_administor": "If you need any help, please contact the system administrator",
        "back": "Back",
        "entered_information": "The information you entered",
        "information_alert": "Please review your information and send it to the system if it is accurate.",
        "no_information": "No information",
        "date_you_added_system": "The date you were added to the system",
        "send_registration": "Send registration",
        "userDeleted": "The user has been deleted",
        "errorOccurredDeleting": "An error occurred while deleting.",
        "UserInformationRestored": "User information restored.",
        "ErrorRetrievingData": "Error retrieving data!",
        "NoSearchResultsFound": "No search results found!",
        "SpacesAreIncluded": "Spaces are included."
    },
    "adminModule": {
        "db": "Database",
        "usersAndUserGroups": "User, User group",
        "users": "Users",
        "userGroupsPermission": "User groups, Permissions",
        "sendDBSchema": "Send Database schema",
        "AddColumn": "Add a column",
        "systemUpdate": "System update",
        "graphic": "Graphic",
        "column": "Column",
        "dataType": "Data type",
        "form": "Form",
        "table": "Table",
        "original_preparation": "Original preparation",
        "pleaseWait": "Please wait",
        "_form": "Form",
        "value_column": "Value column",
        "Custom_column ": "Custom column",
        "list_grid": "List | Grid",
        "Judgment_column ": "Filter column",
        "form_value": "Form (take value)",
        "InformationSuccessfullyDistributed": "Information successfully distributed!",
        "InformationReturned": "Information returned!"
    },
    "graphql": {
        "graphqlManagement": "Graphql management",
        "table": "Table",
        "selectTable": "Select a table",
        "name": "Name",
        "idField": "ID field",
        "hideFields": "Hide fields",
        "permissionActions": "Permission actions",
        "add": "Add",
        "edit": "Edit",
        "delete": "Delete",
        "save": "Save",
        "accessAndAccessRights": "Access and access rights",
        "nevtersenHundHaruulah": "Show it to anyone who has logged in.",
        "accessRights": "Access rights",
        "allUsersCanSee": "All users can see it if they are not authorized",
        "subTables": "Sub-tables",
        "subTable": "Sub-table",
        "connectionField": "Connection field",
        "tableList": "table list",
        "viewList": "View list",
        "real_time": "Real time subscription",
        "cancel": "Cancel",
        "tableParentId": "Table parent ID",
        "action": "Action"
    },
    "components": {
        "add": "Add",
        "pleaseEnterSearchValue": "Please enter a search value...",
        "pleaseWait": "Please wait for a moment!",
        "deleteData": "Are you sure you want to delete your data?",
        "name": "Name",
        "yes": "Yes",
        "no": "No",
        "copy": "Copy",
        "table": "Table",
        "basicTable": "Basic table",
        "selectTable": "Select a table",
        "applications": "Applications",
        "additions": "Additions",
        "logistics": "Logistics",
        "letter": "The letter",
        "fileDirectory": "File directory",
        "admin": "Admin",
        "systemAdministrator": "System administrator",
        "personalInformation": "Personal information",
        "settings": "Settings",
        "logOut": "Log out",
        "changePassword": "Change password ",
        "projectList": "Project list",
        "table_list": "table list",
        "ui_builder": "UI builder",
        "_form": "Form",
        "someContents": "Some contents",
        "_cancel": "Cancel"
    },
    "chart": {
        "horizontal_value": "Horizontal value",
        "groupBy": "group by",
        "line": "Lines",
        "_big": "Large",
        "_small": "Small",
        "field": "Field",
        "settings": "Settings",
        "icon": "Icon",
        "bg_color": "Background color",
        "text_color": "Text color",
        "link_title": "Title link",
        "link": "link",
        "values": "values",
        "element_type": "Element type",
        "_filter": "Filter",
        "_name": "Name",
        "responsible_value": "Responsible value",
        "_save": "Save",
        "enter_name": "Please enter a name...",
        "data_table": "Data table",
        "selectTable": "Select a table",
        "aggregation": "Aggregation",
        "no": "No",
        "count": "Count",
        "_max": "Max",
        "_min": "Min",
        "_avg": "Aug.",
        "_sum": "Sum",
        "count_distinct": "Count Distinct",
        "avg_distinct": "Avg Distinct",
        "sum_distinct": "Sum Distinct",
        "_sort": "Sort",
        "no_sort": "Not sort",
        "grouping": "Grouping",
        "_type": "Type",
        "fictitious_name": "Fictitious name",
        "_color": "Color"
    },
    "dataForm": {
        "save": "Save",
        "pleaseWait": "Please wait for a moment!",
        "fillInTheNewOne": "Fill in the new one",
        "close": "Close",
        "basicSettings": "Basic settings",
        "configureTheData": "Configure the data",
        "trigger": "Trigger",
        "informationLink": "Information link",
        "GetValuesFromTheTable": "Get values from the table",
        "Geographic": "Geographic",
        "AdditionalValues": "Additional values",
        "selectMultipleImg": "Whether to select multiple images",
        "TypeOfTheEditor": "Type of the editor",
        "Placeholder": "Placeholder",
        "default_Value": "Default value",
        "Get_value_parameter": "Get the value from the parameter",
        "Parameter_name": "Name of the parameter",
        "Get_user_ID": "Get a user ID",
        "Consolidation_formula": "Consolidation formula",
        "Whether_to_summarize": "Whether to summarize",
        "Choose_a_formula": "Choose a formula",
        "Formula_type": "Formula type",
        "Take_the_word_before_merger": "If you take the word before the merger",
        "example": "For example ",
        "total": "Total",
        "number": "Number",
        "ets": "ets",
        "Symbol": "Symbol",
        "get_symbol_after_merger": "If you get a symbol after the merger",
        "Verification_conditions": "Verification conditions",
        "Form_of_data_verification": "Form of data verification",
        "Password_settings": "Settings of the password",
        "Password_verification": "Password verification",
        "_pass": "Password",
        "Create_a_password": "Create a password",
        "Check_password_during_editing": "Check the password during editing",
        "number_precision": "Number precision",
        "Whether_get_values_database": "Whether to get values from the database",
        "Choose_multiple_values": "Choose multiple values",
        "value": "Value",
        "visible_word": "A visible word",
        "visible_thumb": "A visible image",
        "add": "Add",
        "table": "Table",
        "selectTable": "Select a table",
        "Related_fields": "Related fields",
        "Visible_fields": "Visible fields",
        "Select_fields": "Select fields",
        "Sort_field": "Sort field",
        "Father_column": "parent id",
        "form": "In the form",
        "this_table ": "This table",
        "Display_Add_Data_button ": "Display the Add Data button",
        "Add_data_Form ": "Add data Form",
        "List_of_tables ": "List of tables",
        "Link_terms ": "Terms of link ",
        "Get_customer ": "Get from the customer",
        "Custom_column ": "Custom column",
        "Judgment_column ": "Filter column",
        "Call_from_server": "Call from server",
        "data_loading_URL": "data loading URL",
        "Trigger_load_time": "Trigger load time",
        "Example_data_returned_server": "Example of data returned from the server",
        "Successful": "Successful",
        "URL_call_information_link": "URL to call the information link",
        "Value_table": "Table of values",
        "Value_return_field": "Value return field",
        "Geographic_settings": "Geographic settings",
        "attribute": "Attribute",
        "properties": "properties",
        "Geometric_type": "Geometric type",
        "point": "Point",
        "line": "Line",
        "polygon": "Polygon",
        "length_center": "The length of the center",
        "latitude_center": "The latitude of the center",
        "Map_magnification": "Map magnification",
        "Background_map": "Background map",
        "Google_Street": "Google Street",
        "Google_Space": "Google Space",
        "Open_Street_Map": "Open Street Map",
        "Check_overlap_area": "Check the overlap of the area",
        "Feature_Class_link": "Feature Class link",
        "Search_field": "Search field",
        "Search_value_field": "Search value field",
        "Success_message": "Success message",
        "Error_message": "Error message",
        "Form_name": "Form name",
        "Sub_name": "Sub name",
        "Form_type": "Form type",
        "Simple_form": "Simple form",
        "Step_by_step_form": "Step-by-step form",
        "data_table": "Data table",
        "idField": "ID field",
        "Date_generated_automatically": "Date generated automatically",
        "render_by_tab": "Section render by tab",
        "Label_location": "Label location",
        "Form_width": "Form width",
        "Save_button_word": "Save button word",
        "Padding_spacing": "Padding - spacing",
        "model": "Model",
        "displayName": "Display name",
        "hide": "Hide",
        "inactive": "Inactive",
        "translation": "Translation",
        "formula": "Formula",
        "userInterface": "User interface",
        "_subform": "Subform",
        "_form": "Form",
        "formula_conditions": "Formula, Conditions",
        "field": "Field",
        "basic_from": "Basic form",
        "conditions": "Conditions",
        "add_a_field": "Add a field",
        "controller_namespace": "Controller namespace",
        "namespace": "Namespace",
        "before_insert": "Before insert",
        "after_insert": "After insert",
        "before_update": "Before update",
        "after_update": "After update",
        "_type": "Type",
        "_top": "top",
        "_left": "left",
        "Choose_type": "Choose a type",
        "min_height": "min-height",
        "Close_deletion_action": "Close the deletion action",
        "close_add_ons_action": "Close the add-ons action",
        "row_numbering": "Row numbering",
        "Use_table_type": "Use Table Type ",
        "Table_Type_field": "Table Type field",
        "Table_Type_value": "Table Type value",
        "Consolidation_forms_and_tables": "Consolidation of forms and tables",
        "_link": "Link",
        "iframe_page": "iframe page",
        "no_action_sub_top": "No Action sub menus to top",
        "No_action": "No action",
        "_division": "Partition",
        "menuType": "Menu type",
        "connectionPath": "Connection path",
        "name": "Name",
        "target": "Target",
        "self": "self",
        "blank": "blank",
        "_new": "new",
        "Get_name": "Get a name",
        "section_add": "Section add",
        "add_column": "Add a column",
        "_delete": "Delete",
        "_move": "Move",
        "graphicsManagement": "Graphics management",
        "viewPhotos": "view photos",
        "createNumber": "create number",
        "other": "other",
        "download": "download",
        "view": "view",
        "pleaseSelectFile": "Please select a file",
        "longitude": "longitude",
        "latitude": "latitude",
        "cancel": "cancel",
        "enterCoordinatesPressEnter": "Enter the coordinates and press Enter?",
        "clickHereSelectPhoto": "Click here to select a photo!",
        "notFound": "not found",
        "confirmPassword": "Confirm password",
        "currentPassword": "Current password",
        "pleaseWriting": "please writing",
        "fromCityCenter": "From the city center",
        "please_enter_value": "Please enter a value",
        "formInformationSavedSuccessfully": "Form information saved successfully.",
        "please_enter_formula": "Please enter a formula",
        "savedSuccessfull": "Saved successfully",
        "errorSaving": "An error occurred while saving!",
        "formIformationSavedSuccessfull": "form information saved successfully.",
        "successDeleted": "successfullyDeleted",
        "selectDefaultMenu": "Select the default menu!",
        "selectMenu": "Please select a menu",
        "pleaseEnterPasswordYouUCurrentlyUsing": "Please enter the password you are currently using",
        "pleaseReEnterYourPassword": "Re-enter your password?",
        "passwordConfirmError": "Password authentication did not match !!!",
        "informationIsIncomplete": "The information is incomplete",
        "trRMandatoryFieldsFillInformationLookFormAFillRequiredFieldsWithRedBorder": "There are mandatory fields to fill in the information. Look at the form and fill in the required fields with a red border!",
        "successfullySaved": "Successfully saved.",
        "pleaseDeleteSubDForm": "Please delete the sub-form",
        "thereZNoRightChangeInformation": "There is no right to change the information",
        "enterCoordinatesCorrectly": "Enter the coordinates correctly",
        "error": "error",
        "theSiteHasNotBeenSelected": "The site has not been selected",
        "noSiteFound": "No site found",
        "dataNotFound": "Data not selected",
        "pleaseCompleteFirstLine": "Please complete the first line",
        "search": "search",
        "values": "values",
        "all": "All"
    },
    "dataGrid": {
        "infoCourt": "Information court",
        "filtering": "filtering",
        "ruSureYouDeleteInfo": "Are you sure you want to delete this information?",
        "yes": "Yes",
        "no": "No",
        "total": "total",
        "updateDataFromExcelFile": "Update data from an Excel file",
        "default_Value": "Default value",
        "methodOfComparison": "Method of comparison",
        "parameterComparison": "Parameter comparison",
        "whetherLookSidebarSearch": "Whether to look in the sidebar search",
        "dataLink": "data link",
        "data_settings": "Datasource",
        "basicSettings": "basic settings",
        "selectTable": "Select a table",
        "table": "Table",
        "tableList": "table list",
        "Related_fields": "Related fields",
        "Visible_fields": "Visible fields",
        "Select_fields": "Select fields",
        "Select_field": "Select field",
        "Sort_field": "Sort field",
        "Father_column": "parent id",
        "Link_terms ": "Terms of link ",
        "inSearch ": "in search",
        "this_table ": "This table",
        "Get_customer ": "Get from the user",
        "custom_column": "Custom column",
        "judgment_column": "filter column",
        "viewList": "View list",
        "image": "Photo",
        "values": "values",
        "visible_word": "A visible word",
        "add": "Add",
        "linkSettings": "link settings",
        "insertList": "insert a link",
        "linkIcon": "icon link",
        "showOnlyIcon": "show only icon",
        "pinColumn": "pin column",
        "linkType": "link type",
        "pinPosition": "pin position",
        "onLeft": "on the left",
        "onRight": "on the right",
        "radioSettings": "Radio settings",
        "additionalSettings": "additional settings",
        "comparativeValue": "comparative value",
        "icon": "icon",
        "colorCode": "color code",
        "easyEdit": "easy edit",
        "copy": "Copy",
        "view": "View",
        "columnFilterButton": "Column filter button",
        "displayTableFrame": "Display the table frame",
        "displayMenuColumn": "Display the menu in the column",
        "showFullText": "Show full text",
        "reboot": "Reboot",
        "download": "download",
        "pleaseSelectFile": "Please select a file",
        "excelUpload": "Excel file upload",
        "exportExcel": "Excel export",
        "landScape": "landscape",
        "portrait": "portrait",
        "paperSize": "paper size",
        "print": "Print",
        "saveSearch": "Save search",
        "pivotTool": "Save search",
        "clientRender": "Client render",
        "numbered": "numbered",
        "comparisonModel": "Comparison model",
        "selectSameValues": "Select the same values",
        "multipleLinesChooseFrom": "Multiple lines to choose from",
        "width": "width",
        "staticWidth": "Static width",
        "destroyedCanBeRestored": "Destroyed can be restored",
        "paging": "paging",
        "edit": "Edit",
        "name": "Name",
        "basic": "Basic",
        "basicTable": "Basic table",
        "idField": "ID field",
        "data_table": "Data table",
        "pleaseWait": "Please wait!",
        "save": "Save",
        "appearanceName": "Appearance name",
        "hide": "Hide",
        "court": "Court",
        "searchResults": "Search results",
        "translation": "Translation",
        "tobePublished": "To be published",
        "updateSelectedLineData": "Update selected line data",
        "whenEnteringDataFromExcelFile": "When entering data from an excel file",
        "Filtersettings": "Filter settings",
        "excel": "Excel",
        "model": "Model",
        "updateSelectedLineDataSettings": "Update the selected line data settings",
        "fieldName": "Field name",
        "buttonName": "Button name",
        "updateAndReboot": "Update and reboot",
        "countingAssociatedInfo": "Counting associated information",
        "relatedTable": "Related table",
        "relatedFields": "Related fields",
        "fatherField": "parent ID",
        "consolidationFormulas": "Consolidation & Formulas",
        "formula": "Formula",
        "resultsStorageArea": "Results storage area",
        "consolidation": "Consolidation",
        "consolidationType": "Consolidation type",
        "consolidationFormula": "Consolidation formula",
        "conditionTrigger": "Condition & Trigger",
        "beforeCallingFromDatabase": "Before calling from the database",
        "afterCallingFromDatabase": "After calling from the database",
        "beforeDeleting": "Before deleting",
        "afterDeleting": "After deleting",
        "beforePrinting": "Before printing",
        "cacheClearTriggerLabel": "Cache clear link",
        "spreadsheetForm": "Spreadsheet form",
        "fromType": "Form type",
        "update": "Updated",
        "post": "Post",
        "editable_UpdateLink": "Editable - update link",
        "fixEntireLine": "Fix the entire line",
        "switchEditMode": "Switch to edit mode",
        "withOneClick": "with one click",
        "highlightChanges": "Highlight changes",
        "saveChangesBulk": "Save changes in bulk",
        "gbExcelImport": "Excel import",
        "excelImportFieldName": "Excel column name",
        "excelImportFormTitle": "Excel import options",
        "excelUploadSampleFile": "Example file",
        "excelUploadRowtoStart": "Excel import start row index",
        "excelUploadCustomUrl": "Excel custom link",
        "excelImportModalTitle": "Import data from Excel",
        "appearance": "Appearance",
        "dataTable": "Data table",
        "filter": "Filter",
        "mini": "Mini",
        "simple": "Simple",
        "size": "Size",
        "controllerNameSpace": "Controller namespace",
        "namespace": "Namespace",
        "BeforeFetch": "Before fetch",
        "AfterFetch": "After fetch",
        "Symbol": "Symbol",
        "type": "type",
        "nickName": "Nick name",
        "filtersAndSelectedLineSettings": "Filters and selected line settings",
        "sort": "Sort",
        "column": "Column",
        "delete": "Delete",
        "actions": "Actions",
        "firstColumn": "first column",
        "buttonEdit": "button edit",
        "doubleClicktoEdit": "double click to edit",
        "actionsField": "Actions field",
        "performActionWithMouse": "Perform the action with the mouse",
        "renew": "Renew",
        "tableHeaderTemplate": "Table header template",
        "createHeaderTemplate": "Create a header template",
        "addLine": "Add a line",
        "addLineBelow": "Add a line below",
        "deleteThisLine": "Delete this line?",
        "addColumnAfterThisColumn": "Add a column after this column",
        "pleaseDeleteThisCell": "Please delete this cell",
        "checkModel": "check the model",
        "height": "height",
        "widthu": "width",
        "row": "row",
        "selectPaperSize": "select the paper size",
        "currencySelection": "currency selection",
        "tugrug": "togrog",
        "dollar": "dollar",
        "euro": "euro",
        "yen": "Japanese yen",
        "austDollar": "Australian dollar",
        "rubli": "rouble",
        "choosevalue": "choose value",
        "pleaseWaitForLoading": "please wait for loading",
        "successfullySaved": "Successfully saved.",
        "formInformationSavedSuccessfully.": "Form information saved successfully.",
        "anErrorOccurredWhileSaving": "An error occurred while saving!",
        "successfullyDeleted": "successfullyDeleted",
        "makeExcel": "Make an excel",
        "plseEnterValue": "please enter a value",
        "updatedSuccessfully": "updated succesfully",
        "infoDeleted": "information deleted",
        "tableDataHasBeenSuccessfullyEdited": " table data has been successfully edited",
        "formInfoSavedSuccessfully": " form information saved successfully.",
        "errorOccurredWhileUpdating": " An error occurred while updating.",
        "pleaseSelectUpdateLine": " Please select an update line.",
        "errorOccWhileDeleting": "An error occurred while deleting",
        "errorMsg": "Sorry, an error occurred",
        "noChangesHaveBeenReported": "No changes have been reported",
        "theme":"Theme"
    },
    "dataSource": {
        "database": "Database",
        "add": "Add",
        "view": "View",
        "pleaseEnterSearchValue": "Please enter a search value...",
        "pleaseWait": "Please wait for a moment!",
        "deleteData": "Are you sure you want to delete your data?",
        "yes": "Yes",
        "no": "No",
        "dataProcessing": "Data processing",
        "characteristics": "Characteristics",
        "basic": "Basic",
        "column": "Column",
        "name": "Name",
        "additional": "Additional",
        "filter": "Filter",
        "data": "Data",
        "save": "Save",
        "tableList": "List of tables",
        "viewList": "View list",
        "aggregation": "Aggregation",
        "sort": "Sort",
        "noSort": "Do not sort",
        "use": "Use",
        "grouping": "Grouping",
        "type": "Type",
        "alias": "Alias",
        "select": "Select",
        "bolomjitTableAndView": "Available Table and view",
        "selectTable": "Select a table",
        "applications": "Applications",
        "errorOccurredWhileSaving": "An error occurred while saving!"
    },
    "role": {
        "administraationRightsManagment": "Administration rights management",
        "welcome": "Welcome!",
        "loggedIn": " Logged in",
        "personalInfo": "Personal information",
        "changePass": "Change password",
        "superAdminManagement": "Super admin management",
        "logout": "Log out",
        "pleaseWait": "Please wait for a moment!",
        "add": "Add",
        "pleaseSelectRole": "Please select role?",
        "role": "Role",
        "additional": "Additional",
        "dataSource": "Data source",
        "userList": "User list",
        "import": "Import",
        "register": "Register",
        "confirm": "Confirm",
        "save": "Save",
        "menuSelection": "Menu selection",
        "possibleTableView": "Possible table and view",
        "table": "Table",
        "name": "Name",
        "displayName": "Display name",
        "note": "Note",
        "cancel": "Cancel",
        "defaultMenu": "Default menu",
        "chart": "Chart",
        "tableName": "table name",
        "table_name": "Table name"
    },
    "project": {
        "project": "PROJECT",
        "settings": "Settings",
        "data_recording_environment": "DATA RECORDING ENVIRONMENT",
        "_form": "Form",
        "table": "Grid",
        "form_and_table_consolidation": "Form and Grid",
        "data_processor": "DATA PROCESSOR",
        "_chart": "Chart",
        "original_preparation": "Original preparation",
        "analysis": "Analysis",
        "target_statement": "Target statement",
        "graphql_management": "Graphql management",
        "menu": "MENU",
        "menu_settings": "Menu settings",
        "data_settings": "Datasource",
        "project_key": "Project key",
        "server_languege_framework": "Server language and framework",
        "create_using": "create using",
        "download_create_file": "Download and create a file",
        "lambda": "Lambda",
        "lambda_cli": "Lambda CLI",
        "lambda_example_app": "Lambda example app",
        "l_key": "key",
        "create": "create",
        "lambda_settings": "Lambda settings",
        "laravel_framework": "PHP: Laravel framework",
        "go_framework": "Go: Echo framework",
        "database": "Database",
        "database_connect": "Database connection",
        "ready": "Ready",
        "_success": "I wish you a success",
        "type": "type",
        "manage_access_rights": "Manage access rights",
        "add": "Add",
        "menuSelection": "Menu selection",
        "default_menu": "Default menu",
        "lambda_platform": "composer create-project lambda-platform/laravel",
        "composer": "Composer",
        "_save": "Save",
        "optional": "Optional",
        "data_source": "Data source",
        "_moqup": "Moqup",
        "user_list": "User list",
        "_import": "Import",
        "register": "Register",
        "_confirm": "Confirm",
        "deleteData": "Are you sure you want to delete your data?",
        "form_value": "Value (Form)",
        "alertSelectColumns": "Please select columns",
        "errorMsg": "An error occurred while saving!",
        "please_wait": "Please wait"
    },
    "puzzle": {
        "manage_access_rights": "Manage access rights",
        "data_recording_environment": "DATA RECORDING ENVIRONMENT",
        "_form": "Form",
        "table": "Grid",
        "form_and_table_consolidation": "Form and Grid",
        "web_page": "Web Page",
        "data_processor": "DATA PROCESSOR",
        "data_settings": "Datasource",
        "_chart": "Chart",
        "original_preparation": "Original preparation",
        "_report": "Report",
        "analysis": "Analysis",
        "target_statement": "Target statement",
        "graphql_management": "Graphql management",
        "usersAndUserGroups": "User, User group",
        "users": "Users",
        "userGroupsPermission": "User groups, Permissions",
        "menu_settings": "Menu settings",
        "logOut": "Log out",
        "cancel": "Cancel",
        "please_wait": "Please wait for a moment",
        "add": "Add",
        "_save": "Save",
        "optional": "Optional",
        "duties": "Duties",
        "_name": "Name",
        "appearance_name": "Appearance name",
        "note": "Note",
        "please_select_role": "Please select a role",
        "data_source": "Data source",
        "_moqup": "Moqup",
        "user_list": "User list",
        "_import": "Import",
        "default_menu": "Default menu",
        "register": "Register",
        "_confirm": "Confirm",
        "list_grid": "List | Grid",
        "custom_column": "Custom column",
        "judgment_column": "Judgment column",
        "value_column": "Value column",
        "delete_data": "Please delete the data",
        "menuSelection": "Menu selection",
        "not_found": "not found",
        "meaningTake": "Meaning to take",
        "filter": "filter"
    },
    "notify": {
        "notice": "Notices",
        "no_notice": "No announcements yet!",
        "view_all_notifications": "View all notifications",
        "total": "Total",
        "clear_notification": "Clear notification"
    },
    "appAdmin": {
        "manual": "Manual",
        "logOut": "Log out",
        "cancel": "Cancel",
        "add": "Add",
        "minus": "Minus",
        "pleaseWait": "Please wait for a moment!",
        "pleaseEnterSearchValue": "Please enter a search value...",
        "delete_data": "Are you sure you want to delete your data?",
        "no": "no",
        "yes": "yes",
        "settings": "Settings",
        "menu_location": "Menu location",
        "stepped": "Stepped",
        "stepped_small": "Stepped small",
        "decomposes": "Decomposes",
        "cross": "Cross",
        "color_selection": "Color selection",
        "dark_mode": "Dark mode",
        "bright_mode": "Bright mode",
        "description": "To add routing information correctly, enter agents from top to bottom when adding agents",
        "data_processor": "Data processor",
        "original_preparation": "Original preparation",
        "dataProcessing": "Data processing",
        "graphics_generator": "Graphics generator",
        "point": "Point"
    },
    "moqup": {
        "elements": "elements",
        "chart": "Chart",
        "save": "save",
        "embedlink": "Embed link",
        "edit": "Edit",
        "phone": "Phone",
        "tablet": "Tablet",
        "computer": "Computer",
        "bigComputer": "Big computer"
    },
    "page": {
        "pageNotFound": "The Page can't be found"
    },
    "alertMessage": {
        "anErrorOccurredWhileSaving": "An error occurred while saving!",
        "successfullyDeleted": "successfullyDeleted",
        "plseEnterValue": "please enter a value",
        "updatedSuccessfully": "updated successfully",
        "infoDeleted": "information deleted",
        "savedSuccessfull": "Saved successfully",
        "confirm": "Confirm",
        "errorOccurredWhileUpdating": " An error occurred while updating.",
        "pleaseSelectUpdateLine": " Please select an update line.",
        "errorOccWhileDeleting": "An error occurred while deleting",
        "errorMsg": "Sorry, an error occurred",
        "noChangesHaveBeenReported": "No changes have been reported",
        "pleaseWait": "Please wait",
        "userDeleted": "The user has been deleted",
        "successDeleted": "Successfully Deleted",
        "userInformationRe": "User information restored",
        "errorRetriev": "An error occurred while restoring the data",
        "notFound": "No search results found!",
        "imformation_registered": "Your information has been successfully registered. Please wait for a moment",
        "errorServer": "An error occurred on the server",
        "errorSendingMail": "An error occurred while sending the email",
        "please_enter_value": "Please enter a value",
        "formInformationSavedSuccessfully": "Form information saved successfully.",
        "please_enter_formula": "Please enter a formula",
        "errorSaving": "An error occurred while saving!",
        "formIformationSavedSuccessfull": "form information saved successfully.",
        "selectDefaultMenu": "Select the default menu!",
        "selectMenu": "Please select a menu",
        "form_value": "Form (take value)",
        "alertSelectColumns": "Select the appropriate columns",
        "please_wait": "Please wait for a moment",
        "pageNotFound": "The Page can't be found"
    },
    "crud": {
        "registration_history": "Registration history",
        "Information_viewing_history": "Information viewing history",
        "_add": "Add",
        "_save": "Save",
        "re_call": "Call again",
        "_print": "Print",
        "download_file": "Download as an Excel file",
        "excelUpload": "Import data from Excel file"
    },
    // "custom": {
    //     "learningManagementSystem": "Learning Management System",
    //     "amjilt": "Amjilt",
    //     "system_features": "System features",
    //     "ebs": "EBS",
    //     "web_site_data_monitoring": "Web site data monitoring",
    //     "training_data_statistics": "Training data statistics",
    //     "schedule_report": "Schedule report",
    //     "track_by_keyword": "Track by keyword",
    //     "to_calculate_the_program_choice_of_teachers_and_students": "To calculate the program choice of teachers and students",
    // },
    i: {...iviewLocale.i}
}
